import { CADSTROM_UUID_SUFFIX_PLACEHOLDER } from '@cadstrom/cadstrom-shared';
import { useQuery } from '@tanstack/react-query';
import { useNavigate } from '@tanstack/react-router';
import { Command } from 'cmdk';

import { CommandBarTypedItem } from '#components/command-bar/components/command-bar-typed-item.js';
import { useTRPC } from '#src/trpc.js';

import type { CadstromUidResultProps } from '../cadstrom-uid-types.js';

/**
 * Renders a command-bar result for a package store package UID (`pkg_...`).
 */
export function PackageUidResult({ uid, onClose }: CadstromUidResultProps) {
	const navigate = useNavigate();
	const trpc = useTRPC();

	const suffixLength = uid.split('_')[1]?.length ?? 0;
	const { data } = useQuery({
		...trpc.package.getManyPreviews.queryOptions({ packageIds: [uid] }),
		enabled: suffixLength >= CADSTROM_UUID_SUFFIX_PLACEHOLDER.length,
	});

	const preview = data?.packagePreviews[0];
	if (!preview) {
		return null;
	}

	return (
		<Command.Group heading='Packages'>
			<Command.Item
				value={uid}
				keywords={[preview.manufacturerPartNumber, preview.manufacturerName, 'package', 'pkg']}
				onSelect={() => {
					void navigate({
						to: '/package-store/$packageFamilyId/packages/$packageId',
						params: { packageFamilyId: preview.packageFamilyId, packageId: preview.id },
					});
					onClose();
				}}
			>
				<CommandBarTypedItem type='package' name={preview.manufacturerPartNumber}>
					{preview.manufacturerName && <span className='font-normal text-gray-a11'>{preview.manufacturerName}</span>}
				</CommandBarTypedItem>
			</Command.Item>
		</Command.Group>
	);
}
